export default {
  selectedItems: [],
  selectedItemsInBundling: [],
  editQuoRecord: {}
}
